import { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";
import { FabWrap, Fab } from "./FloatingActions.styles";

export default function FloatingActions() {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowScroll(window.scrollY > 400);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () =>
    window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <FabWrap>
      <AnimatePresence>
        {showScroll && (
          <Fab
            key="scroll-top"
            onClick={scrollToTop}
            aria-label="Scroll to top"
            initial={{ opacity: 0, scale: 0 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0 }}
            transition={{ duration: 0.2 }}
          >
            <ArrowUp size={20} />
          </Fab>
        )}
      </AnimatePresence>
    </FabWrap>
  );
}
